<template>
  <div
    v-if="extensionDetails?.number"
    class="presence-menu"
  >
    <div class="presence-menu__presences">
      <button
        v-for="item in presenceItems"
        :key="item.id"
        class="presence-menu__presence"
        :class="{
          'presence-menu__presence--active': item.id === selectedPresence?.id,
        }"
        :disabled="item.sub_type.toLowerCase() !== 'other' && item.id === selectedPresence?.id"
        @click="handelUpdateStatus($event, item.id)"
      >
        <img
          v-if="item.icon"
          :alt="item.name"
          :src="item.icon"
          :title="item.name"
        />
        <span class="presence-menu__text">
          {{ item.name }}
          <span
            v-if="item.sub_type.toLowerCase() === 'other' && item.id === selectedPresence?.id"
            class="other-presence-name"
          >
            ({{ currentUserPresence.message }})
          </span>
        </span>
      </button>
    </div>
    <presence-modal
      v-model="showPresenceModal"
      :current-user="currentUserExtension"
    />
  </div>
</template>

<script>
  import { useUserStore } from '@bv/stores/user';
  import { mapState, mapActions } from 'pinia';

  import PresenceModal from '@/components/MainView/SideBar/AccountSettings/PresenceModal.vue';
  import { userDetailsStore } from '@/stores/auth/user-details.store';
  import { usePresence } from '@/stores/general/presence.store';
  import { livePanelStore } from '@/stores/socket/live-panel-socket.store';

  export default {
    name: 'PresenceMenu',
    components: {
      PresenceModal,
    },
    data() {
      return {
        showPresenceModal: false,
      };
    },
    computed: {
      ...mapState(useUserStore, ['extensionDetails']),
      ...mapState(userDetailsStore, ['currentExtension']),
      ...mapState(usePresence, {
        presenceItems: 'getAll',
        selectedPresence: 'currentUserPresence',
      }),
      ...mapState(livePanelStore, ['currentUserExtension', 'currentUserPresence']),
    },
    methods: {
      ...mapActions(usePresence, ['setPresence']),
      closePresenceModal() {
        this.showPresenceModal = false;
      },
      handelUpdateStatus(event, id) {
        const targetPresence = this.presenceItems.find((el) => el.id == id);

        if (targetPresence.has_desc) {
          event.stopPropagation();
          this.showPresenceModal = true;
          return;
        }

        this.$socket.sendAction('setMyPresence', {
          status: targetPresence.status,
          subType: targetPresence.sub_type,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .presence-menu {
    &__presences {
      margin-inline: -8px;
      width: calc(100% + 16px);
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    &__presence {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid transparent;
      background-color: transparent;
      padding: 4px 8px;
      transition: all 300ms ease-in-out;

      &--active {
        border-color: var(--color-base-500, #095ea6);
        background-color: var(--color-base-50, #eff7fe);
      }

      &:disabled {
        cursor: not-allowed;
      }
    }

    &__text {
      font-size: 12px;
      color: var(--gray400, #999);

      .other-presence-name {
        text-transform: capitalize;
      }
    }
  }
</style>
